import React from "react";
import "./StoreActions.css";
import ShareButton from "../../../components/Storefront/ShareStoreComponent";
interface ParticipantStoreActionsProps {
  onViewStore: () => void;
  onShareStore: () => void;
  onAddMoreEmails: () => void;
  copyMessage: string;
  participantID: string;
  participantName?: string;
  organizationName: string;
}

const ParticipantStoreActions: React.FC<ParticipantStoreActionsProps> = ({
  onViewStore,
  onShareStore,
  onAddMoreEmails,
  copyMessage,
  participantID,
  participantName,
  organizationName,
}) => {
  return (
    <div className="participant-store-actions-wrapper">
      <button
        className="participant-store-actions-button"
        onClick={onViewStore}
      >
        View Store
      </button>
      <button
        className="participant-store-actions-button"
        onClick={onAddMoreEmails}
      >
        Add Customer Emails
      </button>
      <ShareButton
        participantID={participantID}
        participantName={participantName}
        organizationName={organizationName}
      />
    </div>
  );
};

export default ParticipantStoreActions;
